import aboutImage from '../Assets/Image/jason-goodman.jpg';
import coinsImage from '../Assets/Image/coins.png';
import globalImage from '../Assets/Image/global.png';
import secureViewImage from '../Assets/Image/secureView.png';
import loyaltyViewImage from '../Assets/Image/loyaltyView.png';
import valueXchangeImage from '../Assets/Image/valueXchange.png';
import kiddyViewImage from '../Assets/Image/kiddyView.png';

const aboutInfo = [
  {
    id: 1,
    title: 'LoyaltyView Market Place',
    body: 'This is a P2P feature that enables subscribers to offer products and services to other subscribers for a fee. Subscribers can also request products and services they need from members of the platform. Payments for these services can be done using the platforms secure payment gateway.',
  },
  {
    id: 2,
    title: ' LoyaltyView BuyNothing',
    body: 'This is a P2P feature that enables subscribers to offer products which they no longer need to other subscribers for FREE. Subscribers can also request products and services they need from members of the platform. Any product listed in LoyaltyView BuyNothing page is for FREE.',
  },
  {
    id: 1,
    title: 'LoyaltyView Make-A-Difference (MAD)',
    body: 'This is a P2P feature that enables subscribers to offer products which they no longer need to other subscribers for FREE. Subscribers can also request products and services they need from members of the platform. Any product listed in LoyaltyView BuyNothing page is for FREE.',
  },
];

export default function About() {
  return (
    <section className='px-4 sm:px-10 md:px-20 max-w-[1440px] mx-auto mt-8 md:mt-24 font-pin'>
      <figure className='grid lg:grid-cols-2 gap-[2rem] items-center'>
        <figcaption className='flex flex-col'>
          <h2 className='text-[1.5rem] font-semibold mb-[1.2rem]'>
            Who we are
          </h2>
          <p className='mb-[1rem] leading-7 text-gray-800'>
            LoyaltyView is an exclusive P2P social commerce digital platform
            that enables its members to trade fX and other items amongst
            themselves in a secure and trusted digital medium.
          </p>

          <p className='leading-7 text-gray-800'>
            The Company LoyaltyView Limited is a FINTECH Services company
            incorporated in the United Kingdom and thus will be regulated under
            the Financial Conduct Authority (FCA). We have been in operation as a non-profit organization
            since 2019. LoyaltyView is also incorporated in Nigeria.
          </p>
        </figcaption>
        <div>
          <img
            src={aboutImage}
            alt='about-img'
            className='w-full h-full object-cover'
          />
        </div>
      </figure>

      <section className='bg-[#F2F2F7] py-8 md:py-14 px-6 rounded-md mt-8'>
        <figure className='grid lg:grid-cols-2 gap-[2rem] items-center rounded-md'>
          <div className='order-last lg:order-first -mx-6 lg:mx-0'>
            <img src={coinsImage} alt='coins-img' className='h-full w-full' />
          </div>
          <figcaption className='pr-6'>
            <h2 className='text-[1.5rem] font-semibold mb-[1.2rem]'>
              What we do
            </h2>
            <p className='leading-7 text-gray-800'>
            In our relentless pursuit of excellence and tailored solutions for our 
            discerning clientele, we go beyond the ordinary. Our suite of services 
            includes LoyaltyView P2P currency exchange, Direct Trading, and Secure 
            Transactions. These offerings are designed to meet the diverse needs of 
            our exclusive clientele, ensuring seamless and reliable experiences every 
            step of the way.
            </p>
          </figcaption>
        </figure>
        {/* <div className='grid lg:grid-cols-3 px:6 lg:px-11 py-8 gap-[1.6rem]'>
          {aboutInfo.map((info) => (
            <article className='flex flex-col'>
              <span
                className='w-[4rem] h-[4rem] bg-[#5AC8FA] grid place-content-center font-pin text-[2.5rem] font-semibold text-white mb-[1rem] lg:mb-[1.8rem]'
                key={info.id}
              >
                {info.id}
              </span>
              <h6 className='text-[1rem] font-semibold mb-[0.5rem] '>
                {info.title}
              </h6>
              <p className='leading-6 text-[1rem] text-gray-700 '>
                {info.body}
              </p>
            </article>
          ))}
        </div> */}
      </section>

      <figure className='grid lg:grid-cols-2 gap-[2rem] items-center py-8 md:py-14'>
        <figcaption className='flex flex-col'>
          <h2 className='text-[1.5rem] font-semibold mb-[1.2rem]'>
            Global Access
          </h2>
          <p className='mb-[1rem] leading-7 text-gray-800'>
            We operate worldwide i.e you can access and use the platform
            services anywhere, anytime. For assistant you can contact support via
            support@loyaltyview.com or you can visit our registered business
            office at:
          </p>

          <p className='leading-7 text-gray-800'>
            71-75 Shelton Street, Covent Garden, London, WC2H 9JQ, United Kingdom <br />
            Affiliate local office: 5B, Ladipo Omotesho Street, Lekki phase 1, Lagos, Nigeria.<br /> 
            Email: hello@loyaltyview.com,
            support@loyaltyview.com
          </p>
        </figcaption>
        <div>
          <img
            src={globalImage}
            alt='about-img'
            className='w-full h-full object-cover'
          />
        </div>
      </figure>
      <section className='bg-[#F2F2F7] py-8 md:py-14 px-6 flex flex-col items-center lg:items-start rounded-md '>
        <h2 className='font-semibold text-[1.4rem] sm:text-[1.8rem] mb-[1rem]'>
          Our Other Products
        </h2>

        <div className='grid xs:grid-cols-2 sm:grid-cols-4 gap-[1.2rem] items-center overflow-hidden  justify-center '>
          {[
            secureViewImage,
            loyaltyViewImage,
            kiddyViewImage,
            valueXchangeImage,
          ].map((img) => (
            <div className='w-full h-[8rem] lg:h-[10rem] bg-white grid place-content-center overflow-hidden rounded-md'>
              <img
                src={img}
                alt='secureView-img'
                className='object-cover h-full w-full object-center'
              />
            </div>
          ))}
        </div>
      </section>
    </section>
  );
}
